import React, { useState } from 'react';
import { ChevronDown, ChevronUp, CalendarHeart } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import CountryFlag from '../common/CountryFlag';
import './UpcomingHolidays.css';

function UpcomingHolidays({ holidays, loading, timeframe }) {
  const [expandedId, setExpandedId] = useState(null);

  const timeframeLabels = {
    today: 'today',
    week: 'this week',
    month: 'this month',
  };

  if (loading) {
    return (
      <div className="upcoming-holidays">
        <div className="upcoming-holidays-header">
          <CalendarHeart size={16} strokeWidth={2} />
          <h3>Upcoming Holidays</h3>
        </div>
        <div className="upcoming-holidays-loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="upcoming-holidays">
      <div className="upcoming-holidays-header">
        <CalendarHeart size={16} strokeWidth={2} />
        <h3>Upcoming Holidays</h3>
        {holidays && holidays.length > 0 && (
          <span className="upcoming-holidays-count">{holidays.length}</span>
        )}
      </div>

      {(!holidays || holidays.length === 0) ? (
        <div className="upcoming-holidays-empty">
          No upcoming holidays {timeframeLabels[timeframe] || 'this week'}
        </div>
      ) : (
        <div className="upcoming-holidays-list">
          {holidays.map((holiday, index) => {
            const key = `${holiday.name}-${holiday.country_code}-${holiday.observed_date}`;
            const isExpanded = expandedId === key;

            return (
              <div key={key} className="upcoming-holiday-item">
                <div
                  className="upcoming-holiday-main"
                  onClick={() => holiday.description && setExpandedId(isExpanded ? null : key)}
                  role={holiday.description ? 'button' : undefined}
                  tabIndex={holiday.description ? 0 : undefined}
                >
                  <div className="upcoming-holiday-info">
                    <span className="upcoming-holiday-name">{holiday.name}</span>
                    <div className="upcoming-holiday-meta">
                      <CountryFlag code={holiday.country_code} size="small" />
                      <span className={`upcoming-holiday-country country-${holiday.country_code?.toLowerCase()}`}>
                        {holiday.country_code}
                      </span>
                      <span className="upcoming-holiday-date">
                        {format(parseISO(holiday.observed_date), 'MMM d')}
                      </span>
                      {holiday.weekend_shifted && (
                        <span className="upcoming-holiday-shifted" title="Shifted from weekend">
                          shifted
                        </span>
                      )}
                    </div>
                  </div>
                  {holiday.description && (
                    <button className="upcoming-holiday-expand" type="button">
                      {isExpanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>
                  )}
                </div>
                {isExpanded && holiday.description && (
                  <div className="upcoming-holiday-description">
                    {holiday.description}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default UpcomingHolidays;
